var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pin-button"},[_c('a-button',{attrs:{"type":_vm.isPinned ? 'primary' : 'default',"size":_vm.sizeToUse,"icon":"pushpin"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }